export default "__VITE_ASSET__4490d4be__"